import RichParams from "./RichParams";
export default RichParams;
